import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';
import { TempCard } from './TempCard.jsx';

// ─── Operations → Temperatures ─────────────────────────────────────────────
// One-glance view of every fridge/freezer/etc. across every location with
// its current temp + 24h sparkline. Helps spot drift before it alarms.
// Manager-gated server-side.
export function TemperaturesOpsView({ user }) {
  const { useState, useEffect } = React;
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const headers = { 'x-user-id': String(user.id) };

  async function load() {
    setLoading(true); setError('');
    try {
      const r = await api('GET', '/api/operations/temperatures', null, headers);
      setData(r);
    } catch (e) { setError(e.message || 'Failed to load'); }
    finally { setLoading(false); }
  }
  useEffect(() => {
    load();
    const t = setInterval(load, 60000); // refresh every 60s
    return () => clearInterval(t);
  }, []);

  if (loading && !data) return <div className="card">Loading temperatures…</div>;
  if (error) return <div className="card" style={{ color: '#b00020' }}>Error: {error}</div>;
  if (!data || !data.locations || data.locations.length === 0) {
    return <div className="card">No equipment with thermometers configured yet. Add a sensor or enable manual logging on a piece of equipment in Equipment.</div>;
  }

  return (
    <div className="space-y-4">
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
          <div>
            <div className="text-base font-semibold">Temperatures</div>
            <div className="text-xs text-gray-500">Current readings + last 24 hours, all locations. Refreshes every 60 seconds.</div>
          </div>
          <button onClick={load} className="btn-secondary" style={{ fontSize: 12 }}>Refresh now</button>
        </div>
      </div>

      {data.locations.map((loc) => (
        <div key={loc.location_id || 'none'} className="card">
          <div style={{ fontSize: 14, fontWeight: 700, color: '#212121', marginBottom: 10,
                        display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ color: 'var(--gold-dark, #b48a47)' }}>📍</span>
            {loc.location_name}
            <span style={{ fontSize: 12, color: '#9e9e9e', fontWeight: 400 }}>
              · {loc.equipment.length} {loc.equipment.length === 1 ? 'unit' : 'units'}
            </span>
          </div>
          <div style={{ display: 'grid', gap: 10,
                        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))' }}>
            {loc.equipment.map((eq) => <TempCard key={eq.id} eq={eq} />)}
          </div>
        </div>
      ))}
    </div>
  );
}
